__turbopack_context__.v({
  "accordion": "iQf8Lq_accordion",
  "accordionContent": "iQf8Lq_accordionContent",
  "accordionContentContainer": "iQf8Lq_accordionContentContainer",
  "accordionHeader": "iQf8Lq_accordionHeader",
  "caret": "iQf8Lq_caret",
  "error": "iQf8Lq_error",
  "headerContainer": "iQf8Lq_headerContainer",
  "subtitle": "iQf8Lq_subtitle",
  "title": "iQf8Lq_title",
});
